// extracted by css-extract-rspack-plugin
export default {"layer":"layer__layer___tIu5a","item":"layer__item___uVAfC"};